import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout/Layouts';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import Dashboard from './components/Dashboard/Dashboards';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import LoadingSpinner from './components/Loading/LoadingSpinner';
import TransactionPage from './components/Transactions/TransactionPage';
import ResetPassword from './components/Auth/ResetPassword';
import Charts from './components/Charts/Charts';
import LauncherPage from './components/Home/LauncherPage';
import WinamaxPage from './components/Winamax/WinamaxPage';
import SubscriptionPage from './components/Subscriptions/SubscriptionPage';
import './App.css';

const AppContent = () => {
  const { appLoading, isAuthenticated } = useAuth();

  if (appLoading) {
    return <LoadingSpinner message="Chargement..." fullScreen={true} />;
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to={isAuthenticated ? '/home' : '/login'} replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/home" element={<ProtectedRoute><LauncherPage /></ProtectedRoute>} />
        <Route path="/gestion-budget/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/gestion-budget/transactions" element={<ProtectedRoute><TransactionPage /></ProtectedRoute>} />
        <Route path="/gestion-budget/charts" element={<ProtectedRoute><Charts /></ProtectedRoute>} />
        <Route path="/gestion-budget/subscriptions" element={<ProtectedRoute><SubscriptionPage /></ProtectedRoute>} />
        <Route path="/gestion-bet/home"         element={<Navigate to="/gestion-bet/recap" replace />} />
        <Route path="/gestion-bet/recap"        element={<ProtectedRoute><WinamaxPage /></ProtectedRoute>} />
        <Route path="/gestion-bet/transactions" element={<ProtectedRoute><WinamaxPage /></ProtectedRoute>} />
        <Route path="/gestion-bet/graphiques"   element={<ProtectedRoute><WinamaxPage /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;
